import uuidv4 from "uuid/v4";

/** @import {FeedbackServiceClientPayload} from './FeedbackServiceClientTypes' */

export const submitFeedback = async (/** @type {string} */ rating, /** @type {string} */ comment, /** @type {number} */ customerId) => {

    let payload = {
        data: {
            feedbackReceivedId: uuidv4(),
            rating: rating,
            comment: comment,
            source: "DigitalSavings",
            jurisdiction: "UK",
            clientId: customerId,
            page: "Dashboard",
            profiles: "DigitalSavings",
            notifications: {
                enableTeamsNotification: false,
            }
        },
        meta: {}
    };
    await sendFeedback(payload);
}

const sendFeedback = (/** @type {FeedbackServiceClientPayload} */ payload) => {
    //TODO - set up jwt token call
    const authToken = "1234"
    // const authToken = window.raeEnv.feedbackServiceClientSecret

    let headers =  {
        'Content-Type': 'application/json',
        ...authToken ? { Authorization: `Bearer ${authToken}` } : {}
    };
    
    if (authToken) {
        headers['Authorization'] = `Bearer ${authToken}`
        
        return new Promise(async (resolve, _reject) => {
            fetch('https://api.nonprod.investec.io/global/feedback/v1/send-feedback', {
                mode: 'no-cors',
                method: 'post',
                headers: headers,
                body: JSON.stringify([payload])
            }).then(() => {
                resolve(undefined);
            }).catch(err => {
                console.log(err)
                resolve(undefined); // TODO don't swallow error
            })
        })
    }
}

